module.exports = __webpack_public_path__ + "img/hypermatic.89504289.png";